import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  dateToday: {
    description: 'Date Range Component dateToday',
    defaultMessage: 'Today',
    id: 'sqmY6G',
  },
  dateYesterday: {
    description: 'Date Range Component dateYesterday',
    defaultMessage: 'Yesterday',
    id: '0+tdiE',
  },
  dateLastWeek: {
    description: 'Date Range Component dateLastWeek',
    defaultMessage: 'In the Last 7 Days',
    id: 's1InE/',
  },
  dateLast30Days: {
    description: 'Date Range Component dateLast30Days',
    defaultMessage: 'In the Last 30 days',
    id: 'DDY6C9',
  },
  dateThisMonth: {
    description: 'Date Range Component dateThisMonth',
    defaultMessage: 'This Month',
    id: 'veAV9M',
  },
  dateLastMonth: {
    description: 'Date Range Component dateLastMonth',
    defaultMessage: 'Last Month',
    id: 'If0ZDB',
  },
  dateCustomRange: {
    description: 'Date Range Component dateCustomRange',
    defaultMessage: 'Custom Range',
    id: 'CI7d/u',
  },
});

const dateFilterOperators = {
  dateToday: 'dateToday',
  dateYesterday: 'dateYesterday',
  dateLastWeek: 'dateLastWeek',
  dateLast30Days: 'dateLast30Days',
  dateThisMonth: 'dateThisMonth',
  dateLastMonth: 'dateLastMonth',
  dateCustomRange: 'dateCustomRange',
};

const DateRangeOptions = [
  {
    id: dateFilterOperators.dateToday,
    displayName: <FormattedMessage {...messages.dateToday} />,
    value: dateFilterOperators.dateToday,
  },
  {
    id: dateFilterOperators.dateYesterday,
    displayName: <FormattedMessage {...messages.dateYesterday} />,
    value: dateFilterOperators.dateYesterday,
  },
  {
    id: dateFilterOperators.dateLastWeek,
    displayName: <FormattedMessage {...messages.dateLastWeek} />,
    value: dateFilterOperators.dateLastWeek,
  },
  {
    id: dateFilterOperators.dateLast30Days,
    displayName: <FormattedMessage {...messages.dateLast30Days} />,
    value: dateFilterOperators.dateLast30Days,
  },
  {
    id: dateFilterOperators.dateThisMonth,
    displayName: <FormattedMessage {...messages.dateThisMonth} />,
    value: dateFilterOperators.dateThisMonth,
  },
  {
    id: dateFilterOperators.dateLastMonth,
    displayName: <FormattedMessage {...messages.dateLastMonth} />,
    value: dateFilterOperators.dateLastMonth,
  },
  {
    id: dateFilterOperators.dateCustomRange,
    displayName: <FormattedMessage {...messages.dateCustomRange} />,
    value: dateFilterOperators.dateCustomRange,
  },
];

export default DateRangeOptions;

export const customDateRangeOption = DateRangeOptions.find((option) => option.id === dateFilterOperators.dateCustomRange);
